import { localize } from "render/context/InternationalizationContext";

const AllSet = localize({
  en_GB: <>You’re all set</>,
  sv_SE: <>Klart</>,
});

const ConfirmationSentViaEmail = localize({
  en_GB: (
    <>
      Thank you. Payment was successful. A confirmation has also been sent by
      email.
    </>
  ),
  sv_SE: (
    <>
      Tack. Betalningen lyckades och redo för nästa steg. Du har även fått en
      bekräftelse på email.
    </>
  ),
});

const CaptureConfirmation = localize({
  en_GB: <>Thank you. Your details are confirmed.</>,
  sv_SE: <>Tack. Dina uppgifter är nu bekräftade.</>,
});

const NextButton = localize({
  en_GB: <>Next</>,
  sv_SE: <>Gå vidare</>,
});

export const Trans = {
  AllSet,
  ConfirmationSentViaEmail,
  CaptureConfirmation,
  NextButton,
};
